import { Link } from "react-router-dom";
import { Database } from "lucide-react";

function Footer() {
  return (
    <footer className="relative w-full text-white overflow-hidden">
      {/* Background (dark, cinematic — NO green glow) */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#060A14] via-[#070D1B] to-[#050913]" />
      <div className="absolute inset-0 -z-10 opacity-[0.06] bg-[linear-gradient(to_right,rgba(255,255,255,0.10)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.10)_1px,transparent_1px)] bg-[size:34px_34px]" />

      {/* Subtle divider (neutral only) */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-white/12 to-transparent" />

      <div className="mx-auto max-w-6xl px-3 sm:px-4 py-3 sm:py-4">
        {/* Single Row - Condensed Layout */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-[11px] sm:text-xs">
          <div className="text-center sm:text-left">
            <p className="text-white/50">
              &copy; {new Date().getFullYear()}{" "}
              <span className="font-semibold text-emerald-300">
                AnimeHouse
              </span>
            </p>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3">
            <Link
              to="/about"
              className="text-white/45 hover:text-emerald-300 transition-colors"
            >
              About
            </Link>
            <span className="text-white/20">•</span>
            <Link
              to="/terms"
              className="text-white/45 hover:text-cyan-200 transition-colors"
            >
              Terms
            </Link>
            <span className="text-white/20">•</span>
            <Link
              to="/privacy"
              className="text-white/45 hover:text-cyan-200 transition-colors"
            >
              Privacy
            </Link>
            <span className="text-white/20">•</span>
            <Link
              to="/feedback"
              className="text-white/45 hover:text-emerald-300 transition-colors"
            >
              Feedback
            </Link>
            <span className="text-white/20 hidden sm:inline">•</span>
            <div className="inline-flex items-center gap-1.5 text-[10px] text-white/35">
              <Database size={9} className="text-cyan-200/50" />
              <a
                href="https://anilist.co"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-200/60 hover:text-cyan-200 transition-colors"
              >
                AniList
              </a>
              <span className="text-white/20">/</span>
              <a
                href="https://jikan.moe"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-200/60 hover:text-cyan-200 transition-colors"
              >
                Jikan
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade edge (neutral, no glow) */}
      <div className="pointer-events-none h-3 bg-gradient-to-b from-transparent to-[#050913]" />
    </footer>
  );
}

export default Footer;
